import firebaseCallable from '../firebaseCallable';

const getFlightStatus = (params) => firebaseCallable('getFlightStatus', params);

export default getFlightStatus;
